<div class="config-details-container p-24">
    <div class="flex flex-row justify-between items-center mb-16">
      <div class="flex flex-col" *ngIf="!results">
          <div class="mat-headline-5 fw-700 mb-8">{{configuration?.manifest?.name }}</div>
          <div>{{configuration?.instanceName}}<span class="config-header ml-16 pl-16">{{'INSTANCE_DETAILS.DATE_GENERATED' | transloco}}: {{configuration?.dateCreated | date: 'dd MMM yyyy, HH:mm' + ' UTC'}}</span></div>
          <div *ngIf="configuration?.hotfix === true" class="hotfix-btn">
            <span class="config-header ml-16 pl-16"></span>
            <button  class="flex flex-row jutsify-center items-center hotfix mt-32 ml-20 mr-140 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
          </div>
      </div>
      <div class="flex flex-col" *ngIf="results">
          <div class="mat-headline-5 fw-700 mb-8">{{'INSTANCE_DETAILS.VIEW_RESULTS' | transloco}}</div>
          <div>{{configuration?.manifest?.name }}<span class="config-header ml-16 pl-16">{{'INSTANCE_DETAILS.VERSION' | transloco}}: {{configuration?.manifest?.version}}</span></div>
          <div *ngIf="configurationState?.hotfix === true" class="hotfix-btn view-result">
            <span class="config-header ml-16 pl-16"></span>
            <button  class="flex flex-row jutsify-center items-center hotfix mt-32 ml-20 mr-140 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
          </div>
      </div>
      <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      </div>
      <mat-divider class="neutral-2 mb-16"></mat-divider>
      @if (configuration?.isReleaseMismatch) {
        <div class="flex flex-col pt-8 pl-12 pb-8 pr-12 warning mb-16">
        <div class="flex items-center warning-header mb-2"><span><mat-icon svgIcon="warning_amber" class="icon-lg release-icon pl-4 pr-4 pb-6 pt-4"></mat-icon></span>
            <span class="fw-700 ml-2 mr-4">{{'INSTANCE_DETAILS.WARNING' | transloco}}</span>
            <span class="fw-500">{{'INSTANCE_DETAILS.VERSION_MISMATCH_HEADER' | transloco}}</span></div>
        <div>{{getReleaseMismatchDescription(configuration)}}</div>
        </div>
      }

      <mat-tab-group animationDuration="0ms" *ngIf="!results">
          <mat-tab *ngIf="configuration.manifest?.config && !isRvt">
              <ng-template mat-tab-label>
                  <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.CONFIGURATION_PACKAGE' | transloco }}</span>
              </ng-template>
              <mat-divider class="neutral-2"></mat-divider>
              <div class="tbl tbl-border tbl-release-package mt-16">
                  <div class="tbl-header-row secondary">
                      <div class="tbl-cell col-filename">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
                      </div>
                      <div class="tbl-cell col-description">
                          {{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}</div>
                  </div>
                  <div class="tbl-body">
                      <div *ngFor="let configurationPackage of configuration.manifest.config.packages" class="tbl-body-row">
                          <div class="tbl-cell col-filename">{{ configurationPackage.name }}</div>
                          <div class="tbl-cell col-description">{{ configurationPackage.description }}</div>
                      </div>
                  </div>
              </div>
          </mat-tab>
          <mat-tab *ngIf="configuration?.manifest?.envProp && !isRvt">
            <ng-template mat-tab-label>
                <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.ENV_PACKAGE' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <div class="tbl tbl-border tbl-test-package mt-16">
                <div class="tbl-header-row secondary">
                    <div class="tbl-cell col-filename">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
                    </div>
                    <div class="tbl-cell col-start-time">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}
                    </div>
                </div>
                <div class="tbl-body">
                    <div *ngFor="let envPackage of configuration.manifest.envProp.packages" class="tbl-body-row">
                        <div class="tbl-cell col-filename">{{ envPackage.name }}</div>
                        <div class="tbl-cell col-description">{{ envPackage.description }}</div>
                    </div>
                </div>
            </div>
        </mat-tab>
          <mat-tab *ngIf="configuration?.manifest?.code && !isRvt">
            <ng-template mat-tab-label>
                <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.CODE_PACKAGE' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <div class="tbl tbl-border tbl-test-package mt-16">
                <div class="tbl-header-row secondary">
                    <div class="tbl-cell col-filename">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
                    </div>
                    <div class="tbl-cell col-start-time">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}
                    </div>
                </div>
                <div class="tbl-body">
                    <div *ngFor="let codePackage of configuration.manifest.code.packages" class="tbl-body-row">
                        <div class="tbl-cell col-filename">{{ codePackage.name }}</div>
                        <div class="tbl-cell col-description">{{ codePackage.description }}</div>
                      </div>
                  </div>
              </div>
          </mat-tab>
          <mat-tab *ngIf="configuration.manifest?.test">
              <ng-template mat-tab-label>
                  <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.TEST_PACKAGE' | transloco }}</span>
              </ng-template>
              <mat-divider class="neutral-2"></mat-divider>
              <div class="tbl tbl-border tbl-test-package mt-16">
                  <div class="tbl-header-row secondary">
                      <div class="tbl-cell col-filename">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.FILE_NAME' | transloco }}
                      </div>
                      <div class="tbl-cell col-start-time">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DESCRIPTION' | transloco }}
                      </div>
                  </div>
                  <div class="tbl-body">
                      <div *ngFor="let testPackage of configuration.manifest?.test?.packages" class="tbl-body-row">
                          <div class="tbl-cell col-filename">{{ testPackage.name }}</div>
                          <div class="tbl-cell col-description">{{ testPackage.description }}</div>
                      </div>
                  </div>
              </div>
          </mat-tab>
          <mat-tab *ngIf="configuration.manifest?.references  && !isRvt">
              <ng-template mat-tab-label>
                  <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.REFERENCE_PACKAGE' | transloco }}</span>
                   @if (configuration?.isReleaseMismatch) {
                    <mat-icon svgIcon="warning_amber" class="icon-lg release-icon p-2 ml-4"></mat-icon>
                  }
                </ng-template>
              <mat-divider class="neutral-2"></mat-divider>
              <div class="tbl tbl-border tbl-test-package mt-16">
                  <div class="tbl-header-row secondary">
                      <div class="tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.IMAGE_NAME' | transloco }}
                      </div>
                      <div class="tbl-cell col-description">
                          {{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.IMAGE_TYPE' | transloco | uppercase }}</div>
                        <div class="tbl-cell col-description col-timestamp">
                          {{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.BUILD_TIME_STAMP' | transloco | uppercase }}</div>
                        <div class="tbl-cell col-description col-artifact">
                          {{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.ARTIFACT' | transloco | uppercase }}</div>
                        <div class="tbl-cell col-description">
                          {{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.VERSION' | transloco | uppercase }}</div>
                  </div>
                  <div class="tbl-body">
                      <div *ngFor="let referencePackage of configuration.manifest?.references?.packages" class="tbl-body-row">
                          <div class="tbl-cell col-filename">{{ referencePackage.name }}</div>
                           <div class="tbl-cell col-description">{{ (referencePackage.imageType) || '-' }}</div>
                          <div class="tbl-cell col-description col-timestamp">{{ (referencePackage.buildTimestamp | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}</div>
                          <div class="tbl-cell col-description col-artifact">{{ (referencePackage.artifact) || '-' }}</div>
                          <div class="tbl-cell col-description">{{ getReferenceVersion(referencePackage.imageName) || '-' }}</div>
                      </div>
                  </div>
              </div>
          </mat-tab>
      </mat-tab-group>
      <mat-tab-group animationDuration="0ms" *ngIf="(results && (configurationState?.codeResult || configurationState?.testResult || configurationState?.configResult || configurationState?.referencesResult))" [ngClass]="{'disable-header': (results && isRvt && (!configurationState?.testResult || configurationState?.testResult?.overview?.packages?.length === 0))}">
          <mat-tab *ngIf="configurationState.configResult && !isRvt">
              <ng-template mat-tab-label>
                  <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.CONFIGURATION_PACKAGE' | transloco }}</span>
              </ng-template>
              <mat-divider class="neutral-2"></mat-divider>
              <div class="tbl tbl-border tbl-configuration-package mt-16">
                  <div class="tbl-header-row secondary">
                      <div class="tbl-cell col-filename pl-8">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
                      <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
                      <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
                      <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
                      <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                    </div>
                  <div class="tbl-body results">
                      <ng-container *ngIf="configurationState.configResult else noDataFound">
                          <div *ngFor="let configurationPackage of configurationState.configResult?.overview.packages" class="tbl-body-row">
                              <div class="tbl-cell col-filename pl-8">{{ configurationPackage.name }}</div>
                              <div class="tbl-cell col-start-time">
                                  {{ (configurationPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                              </div>
                              <div class="tbl-cell col-end-time">
                                  {{ (configurationPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                              </div>
                              <div class="tbl-cell col-duration">
                                  {{ configurationPackage?.startDate | duration : configurationPackage.endDate : '-' }}
                              </div>
                              <div class="tbl-cell col-status">
                                <div class="flex justify-center items-center" [ngClass]="configurationPackage?.status">
                                <span>
                                 <mat-icon *ngIf="configurationPackage?.status === ConfigurationPackageStatus.SUCCESS" svgIcon="check_circle" class="icon-md p-2 mr-4" [ngClass]="configurationPackage?.status"></mat-icon>
                                 <mat-icon *ngIf="configurationPackage?.status === ConfigurationPackageStatus.FAILED" svgIcon="close" class="icon-md p-2 mr-4" [ngClass]="configurationPackage?.status"></mat-icon>
                                 </span>
                                  <span>
                                    {{ (configurationPackage.status | titlecase) || '-' }}
                                  </span>
                                </div>
                                <mat-icon *ngIf = "configurationPackage?.errors"  class="cursor-pointer amber_color ml-20 w-5 h-5" svgIcon="warning_amber"  (click)="configPackErrorDetails(configurationPackage.errors, 'configPack', configurationPackage.name)"></mat-icon>
                              </div>
                             </div>

                      </ng-container>
                      <ng-template #noDataFound>
                          <div class="ta-center p-24">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
                      </ng-template>
                  </div>
              </div>
          </mat-tab>
          <mat-tab *ngIf="configurationState.envPropResult && !isRvt">
              <ng-template mat-tab-label>
                  <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.ENV_PACKAGE' | transloco }}</span>
              </ng-template>
              <mat-divider class="neutral-2"></mat-divider>
              <div class="tbl tbl-border tbl-configuration-package mt-16">
                  <div class="tbl-header-row secondary">
                      <div class="tbl-cell col-filename pl-8">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
                      <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
                      <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
                      <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
                      <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                    </div>
                  <div class="tbl-body results">
                      <ng-container *ngIf="configurationState.envPropResult else noDataFound">
                          <div *ngFor="let configurationPackage of configurationState.envPropResult?.overview.packages" class="tbl-body-row">
                              <div class="tbl-cell col-filename pl-8">{{ configurationPackage.name }}</div>
                              <div class="tbl-cell col-start-time">
                                  {{ (configurationPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                              </div>
                              <div class="tbl-cell col-end-time">
                                  {{ (configurationPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                              </div>
                              <div class="tbl-cell col-duration">
                                  {{ configurationPackage?.startDate | duration : configurationPackage.endDate : '-' }}
                              </div>
                              <div class="tbl-cell col-status">
                                <div class="flex justify-center items-center" [ngClass]="configurationPackage?.status">
                                <span>
                                 <mat-icon *ngIf="configurationPackage?.status === ConfigurationPackageStatus.SUCCESS" svgIcon="check_circle" class="icon-md p-2 mr-4" [ngClass]="configurationPackage?.status"></mat-icon>
                                 <mat-icon *ngIf="configurationPackage?.status === ConfigurationPackageStatus.FAILED" svgIcon="close" class="icon-md p-2 mr-4" [ngClass]="configurationPackage?.status"></mat-icon>
                                 </span>
                                  <span>
                                    {{ (configurationPackage.status | titlecase) || '-' }}
                                  </span>
                                </div>
                                <mat-icon *ngIf = "configurationPackage?.errors"  class="cursor-pointer amber_color ml-20 w-5 h-5" svgIcon="warning_amber"  (click)="configPackErrorDetails(configurationPackage.errors, 'envPack', configurationPackage.name)"></mat-icon>
                              </div>
                             </div>

                      </ng-container>
                      <ng-template #noDataFound>
                          <div class="ta-center p-24">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
                      </ng-template>
                  </div>
              </div>
          </mat-tab>
        <mat-tab *ngIf="configurationState?.codeResult && !isRvt">
            <ng-template mat-tab-label>
                <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.CODE_PACKAGE' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <div class="tbl tbl-border tbl-configuration-package mt-16">
                <div class="tbl-header-row secondary">
                    <div class="tbl-cell col-filename pl-8">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
                    <!-- <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
                    <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
                    <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
                    <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div> -->
                </div>
                <div class="tbl-body results">
                    <ng-container *ngIf="configurationState.codeResult else noDataFound">
                        <div *ngFor="let codePackage of configurationState.codeResult?.packages" class="tbl-body-row">
                            <div class="tbl-cell col-filename pl-8">{{ codePackage?.name }}</div>
                            <!-- <div class="tbl-cell col-start-time">
                                {{ (codePackage?.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                            </div>
                            <div class="tbl-cell col-end-time">
                                {{ (codePackage?.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                            </div>
                            <div class="tbl-cell col-duration">
                                {{ codePackage?.startDate | duration : codePackage?.endDate : '-' }}
                            </div>
                            <div class="tbl-cell col-status" [ngClass]="{
                                'green-1-fg' : codePackage.status === ConfigurationPackageStatus.SUCCESS,
                                'warn-solid-fg': codePackage.status === ConfigurationPackageStatus.FAIL,
                                'neutral-blue-4-fg': !codePackage.status
                            }">{{ codePackage?.status || ('CONFIGURATIONS.VIEW_RESULTS.NOT_EXECUTED' | transloco) }}</div> -->
                        </div>
                      </ng-container>
                      <ng-template #noDataFound>
                          <div class="ta-center p-24">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
                      </ng-template>
                  </div>
              </div>
          </mat-tab>
          <mat-tab *ngIf="(configurationState.skipTest === 'false' || !configurationState.skipTest || isRvt) && configurationState?.testResult">
              <ng-template mat-tab-label>
                  <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.TEST_PACKAGE' | transloco }}</span>
              </ng-template>
              <mat-divider class="neutral-2"></mat-divider>
              <div class="tbl tbl-border tbl-test-package mt-16">
                  <div class="tbl-header-row secondary">
                      <div class="tbl-cell col-filename-test pl-8">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco }}</div>
                      <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}</div>
                      <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
                      <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
                      <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                      <div class="tbl-cell col-success">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.SUCCESS' | transloco }}</div>
                      <div class="tbl-cell col-failure">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FAILURE' | transloco }}</div>
                      <div class="tbl-cell col-download-results"></div>
                      <div class="tbl-cell col-view-results"></div>
                  </div>
                  <div class="tbl-body results">
                      <ng-container *ngIf="configurationState?.testResult else noDataFound">
                          <div *ngFor="let testPackage of configurationState.testResult?.overview.packages" class="tbl-body-row">
                              <div class="tbl-cell col-filename-test pl-8">{{ testPackage.name }}</div>
                              <div class="tbl-cell col-start-time">
                                  {{ (testPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                              </div>
                              <div class="tbl-cell col-end-time">
                                  {{ (testPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                              </div>
                              <div class="tbl-cell col-duration">
                                  {{ testPackage.startDate | duration : testPackage.endDate : '-' }}
                              </div>
                              <div class="tbl-cell col-status" [ngClass]="{
                                  'green-1-fg' : testPackage.status === ConfigurationPackageStatus.SUCCESS,
                                  'warn-solid-fg': testPackage.status === ConfigurationPackageStatus.FAILED,
                                  'neutral-blue-4-fg': !testPackage.status
                              }">
                                  {{ testPackage.status || ('CONFIGURATIONS.VIEW_RESULTS.NOT_EXECUTED' | transloco) }}
                              </div>
                              <div class="tbl-cell col-success ml-12">{{ testPackage.success !== null ?  testPackage.success : '-' }}</div>
                              <div class="tbl-cell col-failure">{{ testPackage.failure !== null ?  testPackage.failure : '-' }}</div>
                              <div class="tbl-cell col-download-results mr-8" [ngClass]="{'disable': !testPackage?.resultsReportFile}" [matTooltip]="testPackage?.resultsReportFile ? '' : ('INSTANCE_DETAILS.VIEW_ICON_TOOLTIP' | transloco)"
                                matTooltipPosition="above"
                                matTooltipClass="mat-tooltip tooltip-inner view-tooltip above pt-8 pr-8 pb-8 pl-8 fs-16">
                                <mat-icon class="cursor-pointer" svgIcon="file_download" (click)="testPackage?.resultsReportFile ? actionClick('download', configurationState, testPackage.resultsReportFile) : ''"></mat-icon>
                              </div>
                              <div class="tbl-cell col-view-results" [ngClass]="{'disable': !testPackage?.resultsReportFile}" [matTooltip]="testPackage?.resultsReportFile ? '' : ('INSTANCE_DETAILS.VIEW_ICON_TOOLTIP' | transloco)"
                                    matTooltipPosition="above"
                                    matTooltipClass="mat-tooltip tooltip-inner view-tooltip above pt-8 pr-8 pb-8 pl-8 fs-16">
                                  <mat-icon class="cursor-pointer" svgIcon="visibility" (click)="testPackage?.resultsReportFile ? actionClick('view', configurationState, testPackage.resultsReportFile, isRvt ? 'RVTResults' : 'TestResults') : ''"></mat-icon>
                              </div>
                          </div>
                      </ng-container>
                      <ng-template #noDataFound>
                          <div class="ta-center p-24">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
                      </ng-template>
                  </div>
              </div>
          </mat-tab>
        <mat-tab *ngIf="configurationState.referencesResult && !isRvt">
            <ng-template mat-tab-label>
                <span class="section-label mat-headline-6">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.REFERENCE_PACKAGE' | transloco }}</span>
                @if (configurationState?.isReleaseMismatch) {
                    <mat-icon svgIcon="warning_amber" class="icon-lg release-icon p-2 ml-4"></mat-icon>
                }
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <div class="tbl tbl-border tbl-configuration-package mt-16">
                <div class="tbl-header-row secondary">
                    <div class="tbl-cell col-filename pl-8">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.IMAGE_NAME' | transloco  }}</div>
                    <div class="tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
                    <div class="tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
                    <div class="tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
                    <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                </div>
                <div class="tbl-body results">
                    <ng-container *ngIf="configurationState.referencesResult else noDataFound">
                        <div *ngFor="let referencePackage of configurationState.referencesResult?.overview.packages" class="tbl-body-row">
                            <div class="tbl-cell col-filename pl-8">{{ referencePackage.name }}</div>
                            <div class="tbl-cell col-start-time">
                                {{ (referencePackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                            </div>
                            <div class="tbl-cell col-end-time">
                                {{ (referencePackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
                            </div>
                            <div class="tbl-cell col-duration">
                                {{ referencePackage?.startDate | duration : referencePackage.endDate : '-' }}
                            </div>
                            <div class="tbl-cell col-status">
                            <div class="flex justify-center items-center" [ngClass]="referencePackage?.status">
                            <span>
                                <mat-icon *ngIf="referencePackage?.status === ConfigurationPackageStatus.SUCCESS" svgIcon="check_circle" class="icon-md p-2 mr-4" [ngClass]="referencePackage?.status"></mat-icon>
                                <mat-icon *ngIf="referencePackage?.status === ConfigurationPackageStatus.FAILED" svgIcon="close" class="icon-md p-2 mr-4" [ngClass]="referencePackage?.status"></mat-icon>
                                </span>
                                <span>
                                {{ (referencePackage.status | titlecase) || '-' }}
                                </span>
                            </div>
                            <mat-icon *ngIf = "referencePackage?.errors"  class="cursor-pointer amber_color ml-20 w-5 h-5" svgIcon="warning_amber"  (click)="configPackErrorDetails(referencePackage.errors, 'referencePack', referencePackage.name)"></mat-icon>
                            </div>
                            </div>

                    </ng-container>
                    <ng-template #noDataFound>
                        <div class="ta-center p-24">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
                    </ng-template>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div *ngIf="( !configurationState?.codeResult && !configurationState?.testResult && !configurationState?.configResult && !configurationState?.referencesResult && results)">
        <div class="ta-center p-24">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</div>
    </div>
      <div *ngIf="results && isRvt && (!configurationState?.testResult || configurationState?.testResult?.overview?.packages?.length === 0)" class="w-100-percent flex justify-center items-center no-data">
        <span class="flex items-center justify-center"><img class="mr-8" src="/assets/images/instance-not-found-small.png">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.NO_DATA_FOUND' | transloco }}</span>
      </div>
  </div>
